import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';

export interface UserUpdateTwoFactorPatchOptions {
  otpEnabled: boolean;
  source?: 'email' | 'authenticator';
  currentPassword: string;
  otpCode?: string;
}

export function userUpdateTwoFactorAuthApi(path: string) {
  return {
    path,
    PATCH: (params: UserUpdateTwoFactorPatchOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: mapFormData(params),
        },
      }),
  };
}
